/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { GetAlerts1$Params, getAlerts1 } from '../fn/alert/get-alerts-1';
import { Alert } from '../models/alert';

/**
 * Alert API
 */
@Injectable({ providedIn: 'root' })
export class AlertService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getAlerts1()` */
   static readonly GetAlerts1Path = '/api/weather/alert';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getAlerts1()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAlerts1$Response(params: GetAlerts1$Params, context?: HttpContext): Observable<StrictHttpResponse<Alert>> {
      return getAlerts1(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getAlerts1$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getAlerts1(params: GetAlerts1$Params, context?: HttpContext): Observable<Alert> {
      return this.getAlerts1$Response(params, context).pipe(map((r: StrictHttpResponse<Alert>): Alert => r.body));
   }
}
